import { render } from "./morning.vue?vue&type=template&id=4d250442&scoped=true"
const script = {}

import "./morning.vue?vue&type=style&index=0&id=4d250442&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d250442"

export default script